import _styled from "@emotion/styled-base";
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import PropTypes from 'prop-types';
import React, { Children, Component } from 'react';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AccordionStyle = _styled("div", {
  target: "eq0lhj80"
})(process.env.NODE_ENV === "production" ? {
  name: "j7qwjs",
  styles: "display:flex;flex-direction:column;"
} : {
  name: "j7qwjs",
  styles: "display:flex;flex-direction:column;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
var Accordion = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Accordion, _Component);
  function Accordion() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.toggleOpenAccordionItem = function () {
      if (_this.props.isOpen && _this.props.openIndex) {
        _this.setState({
          currentOpenIndex: _this.props.openIndex
        });
      } else {
        _this.setState({
          currentOpenIndex: _this.props.isOpen ? 0 : null
        });
      }
    };
    _this.state = {
      currentOpenIndex: null
    };
    _this.handleItemToggle = function (index, props) {
      var currentOpenIndex = _this.state.currentOpenIndex;
      _this.setState({
        currentOpenIndex: index !== currentOpenIndex ? index : null
      }, function () {
        if (props.onHeaderClick) {
          props.onHeaderClick({
            index: index,
            isOpen: _this.state.currentOpenIndex !== null
          });
        }
      });
    };
    return _this;
  }
  var _proto = Accordion.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.toggleOpenAccordionItem();
  };
  _proto.componentDidUpdate = function componentDidUpdate(previousProps) {
    if (previousProps.isOpen !== this.props.isOpen) {
      this.toggleOpenAccordionItem();
    }
  };
  _proto.render = function render() {
    var _this2 = this;
    var _this$props = this.props,
      children = _this$props.children,
      nested = _this$props.nested,
      small = _this$props.small,
      toogleWithText = _this$props.toogleWithText;
    var currentOpenIndex = this.state.currentOpenIndex;
    return ___EmotionJSX(AccordionStyle, null, Children.map(children, function (child, index) {
      return /*#__PURE__*/React.cloneElement(child, {
        isFirst: index === 0,
        isOpen: index === currentOpenIndex,
        onHeaderClick: _this2.handleItemToggle.bind(_this2, index, child.props),
        nested: nested,
        small: small,
        toogleWithText: toogleWithText
      });
    }));
  };
  return Accordion;
}(Component);
Accordion.propTypes = {
  children: PropTypes.node.isRequired,
  isOpen: PropTypes.bool,
  nested: PropTypes.bool,
  onHeaderClick: PropTypes.func,
  small: PropTypes.bool,
  toogleWithText: PropTypes.bool,
  openIndex: PropTypes.number
};
export default Accordion;